import React from 'react';
import { Facebook, Instagram, MapPin, Phone, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-charcoal-900 text-cream-200 pt-16 pb-8" data-id="element-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-22">
          {/* Brand */}
          <div className="space-y-6" data-id="element-23">
            <img src="https://www.downhomeinteriors.com/uploaded/images/newresponsivesite/header/logo.png" alt="Down Home Interiors" className="h-12 w-auto brightness-0 invert opacity-90" data-id="element-24" />
            <p className="text-cream-200/70 text-sm leading-relaxed max-w-xs" data-id="element-25">
              Creating timeless, elegant spaces that feel like home. Visit our
              showroom or book a consultation.
            </p>
            <div className="flex space-x-4" data-id="element-26">
              <a href="https://www.facebook.com/DownTowneApparel/" target="_blank" rel="noopener noreferrer" className="text-cream-200 hover:text-sage-500 transition-colors" aria-label="Facebook" data-id="element-27">
                <Facebook size={20} data-id="element-28" />
              </a>
              <a href="https://www.instagram.com/downhomeinteriors/" target="_blank" rel="noopener noreferrer" className="text-cream-200 hover:text-sage-500 transition-colors" aria-label="Instagram" data-id="element-29">
                <Instagram size={20} data-id="element-30" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-31">
            <h3 className="text-cream-100 font-serif text-lg mb-6" data-id="element-32">Explore</h3>
            <ul className="space-y-3" data-id="element-33">
              <li data-id="element-34">
                <Link to="/about" className="text-cream-200/70 hover:text-sage-500 transition-colors" data-id="element-35">
                  Our Story
                </Link>
              </li>
              <li data-id="element-36">
                <Link to="/portfolio" className="text-cream-200/70 hover:text-sage-500 transition-colors" data-id="element-37">
                  Portfolio
                </Link>
              </li>
              <li data-id="element-38">
                <Link to="/services" className="text-cream-200/70 hover:text-sage-500 transition-colors" data-id="element-39">
                  Services
                </Link>
              </li>
              <li data-id="element-40">
                <Link to="/testimonials" className="text-cream-200/70 hover:text-sage-500 transition-colors" data-id="element-41">
                  Testimonials
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-42">
            <h3 className="text-cream-100 font-serif text-lg mb-6" data-id="element-43">Contact</h3>
            <ul className="space-y-4" data-id="element-44">
              <li className="flex items-start space-x-3 text-cream-200/70" data-id="element-45">
                <MapPin size={18} className="mt-1 flex-shrink-0" data-id="element-46" />
                <a href="https://www.google.com/maps/search/?api=1&query=2729+E.+Grand+River+Ave.+Howell+MI+48843" target="_blank" rel="noopener noreferrer" className="hover:text-sage-500 transition-colors" data-id="element-47">
                  2729 E. Grand River Ave.
                  <br data-id="element-48" />
                  Howell, MI 48843
                </a>
              </li>
              <li className="flex items-center space-x-3 text-cream-200/70" data-id="element-49">
                <Phone size={18} data-id="element-50" />
                <a href="tel:5175455955" className="hover:text-sage-500 transition-colors" data-id="element-51">
                  (517) 545-5955
                </a>
              </li>
              <li className="flex items-center space-x-3 text-cream-200/70" data-id="element-52">
                <Mail size={18} data-id="element-53" />
                <a href="mailto:info@downhomeinteriors.com" className="hover:text-sage-500 transition-colors" data-id="element-54">
                  info@downhomeinteriors.com
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div data-id="element-55">
            <h3 className="text-cream-100 font-serif text-lg mb-6" data-id="element-56">
              Showroom Hours
            </h3>
            <ul className="space-y-2 text-cream-200/70" data-id="element-57">
              <li className="flex justify-between" data-id="element-58">
                <span data-id="element-59">Sunday</span>
                <span data-id="element-60">10:30am - 3:30pm</span>
              </li>
              <li className="flex justify-between" data-id="element-61">
                <span data-id="element-62">Monday</span>
                <span data-id="element-63">10am - 4pm</span>
              </li>
              <li className="flex justify-between" data-id="element-64">
                <span data-id="element-65">Tue - Thu</span>
                <span data-id="element-66">10am - 5:30pm</span>
              </li>
              <li className="flex justify-between" data-id="element-67">
                <span data-id="element-68">Friday</span>
                <span data-id="element-69">10am - 5pm</span>
              </li>
              <li className="flex justify-between" data-id="element-70">
                <span data-id="element-71">Saturday</span>
                <span data-id="element-72">Closed</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-charcoal-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-cream-200/40" data-id="element-73">
          <p data-id="element-74">
            &copy; {new Date().getFullYear()} Down Home Interiors. All rights
            reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-75">
            <span className="hover:text-cream-200 cursor-pointer" data-id="element-76">
              Privacy Policy
            </span>
            <span className="hover:text-cream-200 cursor-pointer" data-id="element-77">
              Terms of Service
            </span>
          </div>
        </div>
      </div>
    </footer>;
}